module.exports = __webpack_public_path__ + "img/photo-21.7b2710df.jpg";